import { useCallback, useEffect, useState } from 'react';
import { DECKS } from '../config/decks';
import { parseMarkdown } from '../domain/cards/parseCards';
import type { Card, DeckId } from '../types';

export function useDecks() {
  const [cards, setCards] = useState<Record<DeckId, Card[]>>({ bs: [], db: [], sec: [], net: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadAll = useCallback(async (force = false) => {
    setLoading(true);
    setError(null);
    try {
      const entries = await Promise.all(DECKS.map(async (deck) => {
        const response = await fetch(deck.file, { cache: force ? 'reload' : 'default' });
        if (!response.ok) throw new Error(`${deck.name}: ${response.status}`);
        const markdown = await response.text();
        return [deck.id, parseMarkdown(markdown)] as const;
      }));
      setCards(Object.fromEntries(entries) as Record<DeckId, Card[]>);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Karten konnten nicht geladen werden.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void loadAll();
  }, [loadAll]);

  return { decks: DECKS, cards, loading, error, reload: loadAll };
}
